import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import { TCalendarDate } from "../../../../components/commons/ono-calendar-v2/calendar_types";

export type Payouts = {
    calendarDate: TCalendarDate;
    pmtType: string;
    amountPaid: string;
    referenceId: string;
    pmtMode: string;
    comments: string
}

type TinitialState = {
    payout: Payouts,
};

const initialState: TinitialState = {
    payout: {
        calendarDate: {
            fromDate: moment().format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
            mode: "ALL"
        },
        pmtType: "",
        amountPaid: "",
        referenceId: "",
        pmtMode: "",
        comments: ""
    }
};

const payoutSlice = createSlice({
    name: "payout",
    initialState: initialState,
    reducers: {
        setPayout: (state, action: PayloadAction<Payouts>) => {
            state.payout = action.payload;
        },
        resetPayouts: (state) => {
            state.payout = initialState.payout;
        },
    },
});

export const {
    setPayout,
    resetPayouts
} =
    payoutSlice.actions;
export default payoutSlice.reducer;
